// Local dev (localhost:3000, running `npm start`) and the live site both
// already share the same production database (see backend/database/mysqli_open.php),
// so there's no real "local backend" — pointing local dev at its own PHP
// server (`php -S localhost:8000`) only diverges on FILE STORAGE: an image
// uploaded while testing locally lands on your own machine's disk, while
// the database row is shared, so the live site then 404s trying to load a
// file that only ever existed on your laptop.
//
// To avoid that mismatch, every environment (local dev included) now talks
// to the same live backend, so anything you upload while testing locally
// is immediately visible on the live site too — there's only one place
// files can end up.
const API_BASE = "https://dialnepal.com.np";

export default API_BASE;
